import { useState } from 'react';
import { Box } from '@mui/material';
import { SubMenu } from './SubMenu';
import {
   Settings,
   Dashboard,
   LineStyle,
   List,
   SettingsApplications,
   MoveUp,
   Facebook,
   SyncAlt,
   Hub,
} from '@mui/icons-material';
import {
   MenuItemLink,
   useSidebarState,
} from 'react-admin';
import { USER_ROLES } from '../config/constants/authConstants';
import { getTableAggregationPath } from '../utils/aggregatedTablesUtils';
import { checkAccess } from '../helpers/authUtils';

export const CustomMenu = ({dense = false}) => {
   const [state, setState] = useState({
      menuSettings: true,
      menuTechSettings: false,
      menuConversionsSync: false,
      menuGoogleAdsBridge: false,
      menuRedirectLinks: false,
      menuSampleSystem: false,
   });
   const [open] = useSidebarState();

   const role = JSON.parse(localStorage.getItem('user')).role;

   const handleToggle = (menu) => {
      setState(state => ({...state, [menu]: !state[menu]}));
   };

   return (
      <Box
         sx={{
            width: open ? 280 : 50,
            marginTop: 1,
            marginBottom: 1,
            transition: theme =>
               theme.transitions.create('width', {
                  easing: theme.transitions.easing.sharp,
                  duration: theme.transitions.duration.leavingScreen,
               }),
         }}
      >
         <MenuItemLink
            to="/"
            primaryText="Home"
            sidebarIsOpen={open}
            leftIcon={<Dashboard/>}
            dense={dense}
         />

         {checkAccess({ role, allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.MEDIA_BUYER, USER_ROLES.MEDIA_MANAGER] }) &&
            <MenuItemLink
               to="/platform_account_settings"
               state={{_scrollToTop: true}}
               primaryText="Ad Accounts"
               dense={dense}
               leftIcon={open ? null : <List/>}
            />
         }

         {checkAccess({
            role,
            allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.MEDIA_BUYER, USER_ROLES.MEDIA_MANAGER]
         }) ?
            <>
               <SubMenu
                  handleToggle={() => handleToggle('menuSettings')}
                  isOpen={state.menuSettings}
                  name="Reports"
                  dense={dense}
                  icon={<Settings/>}
               >

                  <MenuItemLink
                     to="/report_settings"
                     state={{_scrollToTop: true}}
                     primaryText="Report definitions"
                     dense={dense}
                     leftIcon={open ? null : <List/>}
                  />

                  {checkAccess({ role, allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.MEDIA_BUYER] }) &&
                     <>
                        <MenuItemLink
                           to="/campaign_settings"
                           state={{_scrollToTop: true}}
                           primaryText="Campaign mapping"
                           dense={dense}
                           leftIcon={open ? null : <List/>}
                        />

                        <MenuItemLink
                           to="/default_google_campaign_settings"
                           state={{_scrollToTop: true}}
                           primaryText="Google default campaigns"
                           dense={dense}
                           leftIcon={open ? null : <List/>}
                        />
                     </>
                  }

                  <MenuItemLink
                     to="/report_sponsored_settings"
                     state={{_scrollToTop: true}}
                     primaryText="Sponsored brands"
                     dense={dense}
                     leftIcon={open ? null : <List/>}
                  />

                  {checkAccess({ role, allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.MEDIA_BUYER] }) &&
                     <>
                        <MenuItemLink
                           to="/top_brand_settings"
                           state={{_scrollToTop: true}}
                           primaryText="Top brands"
                           dense={dense}
                           leftIcon={open ? null : <List/>}
                        />
                     </>
                  }
               </SubMenu>
            </>
            :
            null
         }

         {checkAccess({ role, allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.MEDIA_BUYER, USER_ROLES.MEDIA_MANAGER] }) ?
            <>
               <SubMenu
                  handleToggle={() => handleToggle('menuConversionsSync')}
                  isOpen={state.menuConversionsSync}
                  name="Conversions Sync"
                  dense={dense}
                  icon={<SyncAlt />}
               >
                  {checkAccess({ role, allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.MEDIA_MANAGER] }) &&
                     <>
                        <MenuItemLink
                           to="/media_platform_api_settings"
                           state={{_scrollToTop: true}}
                           primaryText="Conversions API Settings"
                           dense={dense}
                           leftIcon={open ? null : <List/>}
                        />
                     </>
                  }
                  {checkAccess({ role, allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.MEDIA_MANAGER] }) &&
                     <>
                        <MenuItemLink
                           to={`/${getTableAggregationPath('meta_api_data')}`}
                           state={{_scrollToTop: true}}
                           primaryText="Conversions API Log"
                           dense={dense}
                           leftIcon={open ? null : <Facebook />}
                        />
                     </>
                  }
                  {checkAccess({ role, allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.MEDIA_BUYER] }) &&
                     <>
                        <MenuItemLink
                           to="/conversion_reports"
                           state={{_scrollToTop: true}}
                           primaryText="Offline Conversion Uploads"
                           dense={dense}
                           leftIcon={open ? null : <List/>}
                        />
                     </>
                  }
               </SubMenu>
            </>
            :
            null
         }

         {checkAccess({ role, allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.MEDIA_MANAGER] }) ?
            <>
               <SubMenu
                  handleToggle={() => handleToggle('menuGoogleAdsBridge')}
                  isOpen={state.menuGoogleAdsBridge}
                  name="Google Ads Bridge"
                  dense={dense}
                  icon={<Hub />}
               >
                  {checkAccess({ role, allowedRoles: [USER_ROLES.ADMIN] }) &&
                     <>
                        <MenuItemLink
                           to="/google_ads_bridges"
                           state={{_scrollToTop: true}}
                           primaryText="Connected Accounts"
                           dense={dense}
                           leftIcon={open ? null : <List/>}
                        />
                     </>
                  }
                  {checkAccess({ role, allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.MEDIA_MANAGER] }) &&
                     <>
                        <MenuItemLink
                           to="/ads_jobs"
                           state={{_scrollToTop: true}}
                           primaryText="Jobs"
                           dense={dense}
                           leftIcon={open ? null : <List/>}
                        />
                     </>
                  }
                  {checkAccess({ role, allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.MEDIA_MANAGER] }) &&
                     <>
                        <MenuItemLink
                           to="/ads_ingest_runs"
                           state={{_scrollToTop: true}}
                           primaryText="Data Deliveries"
                           dense={dense}
                           leftIcon={open ? null : <List/>}
                        />
                     </>
                  }
                  {checkAccess({ role, allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.MEDIA_MANAGER] }) &&
                     <>
                        <MenuItemLink
                           to="/ads_actions"
                           state={{_scrollToTop: true}}
                           primaryText="Action Approvals"
                           dense={dense}
                           leftIcon={open ? null : <List/>}
                        />
                     </>
                  }
                  {checkAccess({ role, allowedRoles: [USER_ROLES.ADMIN] }) &&
                     <>
                        <MenuItemLink
                           to="/ads_write_settings"
                           state={{_scrollToTop: true}}
                           primaryText="Safety Limits"
                           dense={dense}
                           leftIcon={open ? null : <List/>}
                        />
                     </>
                  }
               </SubMenu>
            </>
            :
            null
         }

         {checkAccess({ role, allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.CONTENT_MEDIA_MANAGER] }) ?
            <SubMenu
               handleToggle={() => handleToggle('menuRedirectLinks')}
               isOpen={state.menuRedirectLinks}
               name="Redirect Links"
               dense={dense}
               icon={<MoveUp/>}
            >
               <MenuItemLink
                  to="/articles_setup"
                  state={{_scrollToTop: true}}
                  primaryText="Articles"
                  dense={dense}
                  leftIcon={open ? null : <List/>}
               />
               <MenuItemLink
                  to="/redirect_domains"
                  state={{_scrollToTop: true}}
                  primaryText="Domains"
                  dense={dense}
                  leftIcon={open ? null : <List/>}
               />
               <MenuItemLink
                  to="/redirect_links"
                  state={{_scrollToTop: true}}
                  primaryText="Links"
                  dense={dense}
                  leftIcon={open ? null : <List/>}
               />
            </SubMenu>
            :
            null
         }
         {checkAccess({
            role,
            allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.CONTENT_MEDIA_MANAGER, USER_ROLES.AFFILIATE_MANAGER]
         }) ?
            <SubMenu
               handleToggle={() => handleToggle('menuSampleSystem')}
               isOpen={state.menuSampleSystem}
               name="Samples"
               dense={dense}
               icon={<List/>}
            >
               <MenuItemLink
                  to="/sample_system/affiliate_sample_requests"
                  state={{_scrollToTop: true}}
                  primaryText="Affiliate Sample Requests"
                  dense={dense}
                  leftIcon={open ? null : <List/>}
               />
               <MenuItemLink
                  to="/sample_system/affiliate_access"
                  state={{_scrollToTop: true}}
                  primaryText="Affiliate Access"
                  dense={dense}
                  leftIcon={open ? null : <List/>}
               />
               <MenuItemLink
                  to="/sample_system/advertiser_access"
                  state={{_scrollToTop: true}}
                  primaryText="Advertiser Access"
                  dense={dense}
                  leftIcon={open ? null : <List/>}
               />
            </SubMenu>
            :
            null
         }
         {checkAccess({ role, allowedRoles: [USER_ROLES.ADMIN] }) &&
            <>
               <SubMenu
                  handleToggle={() => handleToggle('menuTechSettings')}
                  isOpen={state.menuTechSettings}
                  name="Admin"
                  dense={dense}
                  icon={<SettingsApplications/>}
               >
                  <MenuItemLink
                     to="/cron_settings"
                     state={{_scrollToTop: true}}
                     primaryText="Crons"
                     dense={dense}
                     leftIcon={open ? null : <List/>}
                  />
                  <MenuItemLink
                     to="/user_settings"
                     state={{_scrollToTop: true}}
                     primaryText="Users"
                     dense={dense}
                     leftIcon={open ? null : <List/>}
                  />
               </SubMenu>
            </>
         }

         {checkAccess({
            role,
            allowedRoles: [ USER_ROLES.ADMIN ] 
         }) ? <MenuItemLink
               to="/action_logs"
               primaryText="Activity Log"
               sidebarIsOpen={open}
               leftIcon={<LineStyle/>}
               dense={dense}
            />
            : null
         }
      </Box>
   );
};